import { writable } from "svelte/store";

function createStore() {
    const { subscribe, set, update } = writable({
        isTalking: false
    });

    return {
        subscribe,
        set,

        start() {
            update((state) => ({ ...state, isTalking: true }));
        },

        end() {
            update((state) => ({ ...state, isTalking: false }));
        }
    };
}

const store = createStore();

export default store;
